import React from 'react';
import Loader from '../../loader';

const LoadingIndicator = () => <Loader />;

export default LoadingIndicator;
